<template>
  <login-personalize-preview-panel-section class="login-personalize-preview-section-local">
    <login-personalize-local-modal v-model="showingLocalModal"
                                   :item="item"
                                   @saved="emitSaved" />
  </login-personalize-preview-panel-section>
</template>

<script>
import LoginPersonalizeLocalModal from "@components/modules/login-personalize/local/modal/LoginPersonalizeLocalModal";
import LoginPersonalizePreviewPanelSection from "@components/modules/login-personalize/preview/panel/section/LoginPersonalizePreviewPanelSection";

export default {
  components: {
    LoginPersonalizePreviewPanelSection,
    LoginPersonalizeLocalModal,
  },

  data() {
    return {
      showingLocalModal: false,
    };
  },

  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    item: {
      type: Object,
    },
  },

  computed: {},

  methods: {
    emitSaved(config) {
      this.$emit("saved", config);
    },
  },

  created() {},

  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.login-personalize-preview-section-local {
  display: flex;
  justify-content: center;
}
</style>
